import styled from "styled-components";
import { paletas } from "../../styles/theme";

interface StylesProps {
  color: string;
  background: string;
  border: string;
  size: string;
}

export const Wrapper = styled.button<StylesProps>`
  font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
  font-weight: bold;
  width: 100%;
  font-size: ${(props) => props.size};
  color: ${(props) => props.color ?? paletas.Grafite75};
  background: ${(props) => props.background ?? paletas.Grafite25};
  border: 1px solid ${(props) => props.border};
  border-radius: 0.25rem;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    color: ${(props) => props.background ?? paletas.Grafite25};
    background: ${(props) => props.color ?? paletas.Grafite75};
    border: 1px solid ${(props) => props.border};
  }
  &:disabled {
    opacity: 0.3;
  }
  @media (max-width: 576px) {
    font-size: 18px;
  }
`;
